import React, { useContext } from "react";
import style from "./index.module.scss";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";
import { useAtomValue } from "jotai";
import {
    exerciseInfoAtom,
    staticsAtom,
    totalScoreAtom
} from "service/stores/Exercise/Statics";

export default function ExerciseStaticsButtons() {
    const history = useHistory();
    const { basename } = useContext(CourseContext);
    const exerciseInfo = useAtomValue(exerciseInfoAtom);
    const { questionList } = useAtomValue(staticsAtom);
    const score = useAtomValue(totalScoreAtom);

    return (
        <div className={style.root}>
            <div className={style.count}>
                共 {questionList.length} 题， {score} 分
            </div>

            <div className={style.buttons}>
                <button
                    className={style.button}
                    onClick={() =>
                        history.replace(
                            `${basename}/exercise/students/${exerciseInfo.exerciseId}`
                        )
                    }>
                    前往批阅练习
                </button>
            </div>
        </div>
    );
}
